import React from 'react';
import { Smartphone, Sparkles, Upload, Video, Play, Music, Layout, Sliders, Bell } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import styles from './SelfEditApp.module.css';

const SelfEditApp = () => {
  const { t } = useLanguage();

  const handleNotifyClick = () => {
    const phoneNumber = "917533928185";
    const waMessage = encodeURIComponent("Hello Ananta Team, I'm interested in the upcoming News Editor App (Coming Soon). Please notify me when it launches!");
    window.open(`https://wa.me/${phoneNumber}?text=${waMessage}`, '_blank');
  };

  return (
    <section className={styles.section} id="editor-app">
      <div className={styles.wrapper}>
        
        {/* Left Side: Info */}
        <div className={styles.infoCol}>
          <div className={styles.badge}>
            <Sparkles size={14} className={styles.sparkleIcon} /> {t('app_badge')}
          </div>
          <h2 className={styles.title}>
            {t('app_title')}
          </h2>
          <p className={styles.description}>
            {t('app_desc1')}
          </p>
          <p className={styles.descriptionSecondary}>
            {t('app_desc2')}
          </p>
          <div className={styles.priceTag}>
            {t('app_price_tag')}
          </div>
          
          <button className={styles.notifyBtn} onClick={handleNotifyClick}>
            <Bell size={18} /> {t('app_btn')}
          </button>
        </div>

        {/* Right Side: Interactive App Mockup */}
        <div className={styles.visualCol}>
          <div className={styles.appContainer}>
            {/* Top Bar of the Mockup */}
            <div className={styles.appTopBar}>
              <div className={styles.appControls}>
                <div className={`${styles.dot} ${styles.red}`} />
                <div className={`${styles.dot} ${styles.yellow}`} />
                <div className={`${styles.dot} ${styles.green}`} />
              </div>
              <div className={styles.appTitleBar}>
                <Smartphone size={12} /> ananta-news-editor-v1.0.exe
              </div>
            </div>

            {/* Grid layout of Mockup */}
            <div className={styles.appBodyGrid}>
              
              {/* Left Side of Mockup: Upload Inputs */}
              <div className={styles.mockSidebar}>
                <div className={styles.mockSidebarItem}>
                  <Upload size={14} color="#e87355" />
                  <span>Upload Audio</span>
                </div>
                <div className={styles.mockSidebarItem}>
                  <Video size={14} color="#5ba5e0" />
                  <span>Footage & B-Roll</span>
                </div>
                <div className={styles.mockSidebarItem}>
                  <Layout size={14} color="#e87355" />
                  <span>Templates</span>
                </div>
                <div className={styles.mockSidebarItem}>
                  <Sliders size={14} color="#5ba5e0" />
                  <span>AI Voice Control</span>
                </div>
              </div>

              {/* Center Main: Preview & Timeline */}
              <div className={styles.mockMain}>
                <div className={styles.previewWindow}>
                  <div className={styles.previewHeader}>
                    <div className={styles.liveIndicator}>● PREVIEW</div>
                    <span>1080p HD</span>
                  </div>
                  
                  {/* Virtual Video Canvas */}
                  <div className={styles.videoCanvas}>
                    <div className={styles.virtualAnchor}>
                      <div className={styles.anchorGlow} />
                      <div className={styles.faceCloneGlow} />
                      <div className={styles.virtualLogo}>NEWS</div>
                    </div>
                    <div className={styles.newsHeadlineBar}>
                      <div className={styles.tickerRed}>BREAKING NEWS</div>
                      <div className={styles.tickerText}>ANANTA AI EDITOR APP LAUNCHING SOON...</div>
                    </div>
                  </div>
                </div>

                {/* Video Track Timelines */}
                <div className={styles.timelineContainer}>
                  <div className={styles.timelineTrack}>
                    <div className={styles.trackLabel}><Video size={12} /> Video</div>
                    <div className={styles.trackBar} style={{ width: '85%', background: 'linear-gradient(90deg, #e87355 30%, #ff5e3a 70%)' }}>Anchor Track</div>
                  </div>
                  <div className={styles.timelineTrack}>
                    <div className={styles.trackLabel}><Play size={12} /> B-Roll</div>
                    <div className={styles.trackBar} style={{ width: '60%', background: 'linear-gradient(90deg, #5ba5e0 40%, #8ac4ff 80%)', marginLeft: '20%' }}>Overlay B-Roll</div>
                  </div>
                  <div className={styles.timelineTrack}>
                    <div className={styles.trackLabel}><Music size={12} /> Audio</div>
                    <div className={styles.trackBar} style={{ width: '90%', background: 'rgba(232, 115, 85, 0.2)', border: '1px dashed #e87355' }}>Voice.wav</div>
                  </div>
                </div>

              </div>

            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default SelfEditApp;
